<div class="min-h-screen bg-gradient-to-br from-amber-50 via-white to-amber-100 py-12 mt-20">
  <!-- Decorative elements -->
  <div class="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
    <div class="absolute top-10 left-10 w-32 h-32 bg-yellow-300 rounded-full opacity-20 animate-pulse"></div>
    <div class="absolute bottom-10 right-10 w-24 h-24 bg-amber-400 rounded-full opacity-20 animate-pulse delay-700"></div>
    <div class="absolute top-1/3 right-1/4 w-16 h-16 bg-yellow-200 rounded-full opacity-30 animate-pulse delay-300"></div>
  </div>

  <div class="flex flex-col md:flex-row relative z-10">
    <!-- Sidebar -->
<perfil-user-component-sidebar></perfil-user-component-sidebar>
    <!-- Content -->
    <div class="flex-1 bg-white rounded-lg shadow-lg p-6 mt-6 md:mt-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
